import { render, staticRenderFns } from "./SyllabusProgressDisplay.vue?vue&type=template&id=681439c1&scoped=true"
import script from "./SyllabusProgressDisplay.vue?vue&type=script&lang=js"
export * from "./SyllabusProgressDisplay.vue?vue&type=script&lang=js"
import style0 from "./SyllabusProgressDisplay.vue?vue&type=style&index=0&id=681439c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681439c1",
  null
  
)

export default component.exports